import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function TestimonialSection() {
  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Quote className="text-primary mx-auto mb-6" size={40} />
          <blockquote className="text-xl md:text-2xl text-foreground/90 leading-relaxed font-body italic mb-6">
            "Huippu paikka kaikinpuolin. Riittävästi rautaa nostettavaksi. Henkilökunta ystävällistä ja rentoa. Plussaa myös hyvä ja ammattitaitoinen hieroja."
          </blockquote>
          <div className="divider-primary mx-auto mb-4" />
        </motion.div>
      </div>
    </section>
  );
}
